import promo from "./promo.vue";

export default Vue => {
  Vue.component("promo", promo);
};
